import { AlertTriangle, CheckCircle2, Bot } from 'lucide-react'
import { useAuthStore } from '../store/authStore'

// Traducción condicional por host — cad.retaliq.net es la demo en inglés para
// Cement India; el resto queda en español.
const _isEN = typeof window !== 'undefined' && window.location.hostname === 'cad.retaliq.net'
const T = {
  criticalOne : _isEN ? 'critical'          : 'crítico',
  criticalMany: _isEN ? 'critical'          : 'críticos',
  activeOne   : _isEN ? 'active alert'      : 'alerta activa',
  activeMany  : _isEN ? 'active alerts'     : 'alertas activas',
  systemOK    : _isEN ? 'All Systems Normal': 'Sistema OK',
  aiAssistant : _isEN ? 'AI Assistant'      : 'Asistente IA',
  ai          : _isEN ? 'AI'                : 'IA',
  logout      : _isEN ? 'Sign out'          : 'Salir',
}

export default function TopBar({ title, subtitle, alerts = [], onChatToggle, chatOpen }) {
  const user   = useAuthStore(s => s.user)
  const logout = useAuthStore(s => s.logout)

  const critical = alerts.filter(a => a.severity === 'critical').length
  const open     = alerts.filter(a => a.status === 'open' || a.status === 'acknowledged').length

  return (
    <header style={{
      height: 'var(--topbar-h)', background: 'var(--bg-surface)',
      borderBottom: '1px solid var(--border)',
      display: 'flex', alignItems: 'center', padding: '0 16px', gap: 12,
      flexShrink: 0,
    }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)' }}>{title}</span>
        {subtitle && <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{subtitle}</span>}
      </div>

      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
        {critical > 0 && (
          <span style={{
            fontSize: 11, fontWeight: 500, padding: '3px 8px', borderRadius: 20,
            background: 'var(--danger-light)', color: 'var(--danger-text)',
            display: 'flex', alignItems: 'center', gap: 4,
          }}>
            <AlertTriangle size={11} />
            {critical} {critical > 1 ? T.criticalMany : T.criticalOne}
          </span>
        )}
        {open > 0 && critical === 0 && (
          <span style={{
            fontSize: 11, fontWeight: 500, padding: '3px 8px', borderRadius: 20,
            background: 'var(--warning-light)', color: 'var(--warning-text)',
            display: 'flex', alignItems: 'center', gap: 4,
          }}>
            <AlertTriangle size={11} />
            {open} {open > 1 ? T.activeMany : T.activeOne}
          </span>
        )}
        {open === 0 && (
          <span style={{
            fontSize: 11, fontWeight: 500, padding: '3px 8px', borderRadius: 20,
            background: 'var(--success-light)', color: 'var(--success-text)',
            display: 'flex', alignItems: 'center', gap: 4,
          }}>
            <CheckCircle2 size={11} />
            {T.systemOK}
          </span>
        )}

        <div style={{ width: 1, height: 20, background: 'var(--border)', margin: '0 4px' }} />

        <button
          onClick={onChatToggle}
          title={T.aiAssistant}
          style={{
            display: 'flex', alignItems: 'center', gap: 6,
            padding: '4px 10px', borderRadius: 'var(--radius-sm)',
            border: chatOpen ? 'none' : '1px solid var(--border)',
            background: chatOpen ? 'var(--accent)' : 'transparent',
            color: chatOpen ? '#fff' : 'var(--text-muted)',
            cursor: 'pointer', fontSize: 12, fontWeight: 500,
            transition: 'all 0.15s',
          }}
        >
          <Bot size={13} />
          <span>{T.ai}</span>
        </button>

        <div style={{ width: 1, height: 20, background: 'var(--border)', margin: '0 4px' }} />

        <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{user?.nombre}</span>
        <span style={{
          fontSize: 10, fontWeight: 600, padding: '2px 6px', borderRadius: 4,
          background: 'var(--bg-muted)', color: 'var(--text-muted)',
          textTransform: 'uppercase', letterSpacing: '0.05em',
        }}>{user?.rol}</span>

        <button
          onClick={logout}
          style={{
            background: 'transparent', border: '1px solid var(--border)',
            borderRadius: 'var(--radius-sm)', padding: '4px 10px',
            fontSize: 11, color: 'var(--text-muted)', cursor: 'pointer',
          }}
        >
          {T.logout}
        </button>
      </div>
    </header>
  )
}
